import React from 'react';
import { MaxWidth } from '../../../types/ui/Layout';
import { useScrollLock } from '../../../hooks/useScrollLock';
import { useEscapeKey } from '../../../hooks/useEscapeKey';

interface PdfModalLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  maxWidth?: MaxWidth;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  footerContent?: React.ReactNode;
}

const PdfModalLayout: React.FC<PdfModalLayoutProps> = ({
  isOpen,
  onClose,
  title = 'Documento de Venta',
  leftContent,
  rightContent,
  footerContent,
}) => {
  useScrollLock(isOpen);
  useEscapeKey(() => {
    if (isOpen) onClose();
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex h-screen w-screen bg-black/80">
      <div className="flex h-full w-full flex-col bg-white dark:bg-meta-4">
        {/* Encabezado */}
        <div className="flex items-center justify-between border-b border-stroke px-4 py-3 dark:border-strokedark sm:px-6 sm:py-4">
          <h2 className="text-gray-900 text-base font-semibold dark:text-white sm:text-lg">
            {title}
          </h2>
          <button onClick={onClose}>
            <svg
              className="text-gray-500 hover:text-gray-700 dark:text-gray-300 h-5 w-5 dark:hover:text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.89 10L19.5 2.39a1 1 0 10-1.42-1.42L10.47 8.59 2.86 0.97A1 1 0 101.44 2.39L9.06 10l-7.62 7.61a1 1 0 101.42 1.42l7.61-7.61 7.61 7.61a1 1 0 101.42-1.42L11.89 10z"
              />
            </svg>
          </button>
        </div>

        {/* Contenido principal */}
        <div className="flex flex-1 flex-col overflow-hidden lg:flex-row">
          {/* Lado izquierdo */}
          <aside className="w-full flex-shrink-0 border-b border-stroke bg-slate-100 px-4 py-4 dark:border-strokedark dark:bg-slate-800 sm:px-6 sm:py-6 lg:max-w-sm lg:border-b-0 lg:border-r">
            {leftContent}
          </aside>

          {/* Lado derecho */}
          <section className="flex-1 overflow-auto bg-white px-4 py-4 dark:bg-boxdark sm:px-6 sm:py-6">
            {rightContent}
          </section>
        </div>

        {/* Pie de página */}
        <footer className="border-t border-stroke px-4 py-3 dark:border-strokedark sm:px-6 sm:py-4">
          {footerContent}
        </footer>
      </div>
    </div>
  );
};

export default PdfModalLayout;
